import React, { useEffect, useState } from "react";
import DateFilter from "../../../components/Date";
import DropdownFilter from "../../../components/DropdownFilter";
import { useSelector } from "react-redux";
import callApi from "../../../services/api/apiClient";
import LoadingComponent from "../../../components/loading/LoadingComponent";
import moment from "moment/moment";

const ProductandCategory = () => {
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateError, setDateError] = useState("");
  // const [selectedUsergroup, setSelectedUsergroup] = useState("usergroup");
  const [selectedCategory, setSelectedCategory] = useState("category");
  const [selectedProduct, setSelectedProduct] = useState("product");
  // const [currentPage, setCurrentPage] = useState(1);
  const [allProductType, setAllProductType] = useState([]);
  // const ordersPerPage = 5;

  const productType = useSelector((state) => state?.product?.type?.data);
  // console.log(productType, "producttype");
  const category = useSelector((state) => state?.product?.getAllCategory?.data);
  console.log(category, "category");

  const userGroup = useSelector((state) => state?.user?.getUserGroup?.data);
  const productReport = useSelector(
    (state) => state?.report?.ProductandCategory?.data
  );
  // console.log(productReport, "productreport");

  const validateDates = (from, to) => {
    if (from && to && moment(from).isAfter(to)) {
      setDateError("From Date cannot be later than To Date");
      console.log(dateError, "dateError");
      return false;
    }
    setDateError("");
    return true;
  };

  const handleFromDateChange = (date) => {
    if (validateDates(date, toDate)) {
      setFromDate(date);
    }
  };

  const handleToDateChange = (date) => {
    if (validateDates(fromDate, date)) {
      setToDate(date);
    }
  };

  useEffect(() => {
    getuserGroups();
    if (productType?.length > 0) {
      setAllProductType([{ id: 999999, name: "All" }, ...productType]);
    }
  }, [productType]);

  const getuserGroups = async () => {
    await callApi("user/getUserGroup").loadingGroup("user").executeDispatch();
  };
  useEffect(() => {
    getProducts();
  }, []);
  const getProducts = async () => {
    await callApi("product/type").loadingGroup("product").executeDispatch();
  };

  useEffect(() => {
    getCategories();
  }, []);
  const getCategories = async () => {
    await callApi("product/getAllCategory")
      .loadingGroup("category")
      .executeDispatch();
  };

  useEffect(() => {
    if (validateDates(fromDate, toDate)) {
      getProductandCategory();
    }
  }, [fromDate, toDate, selectedProduct, selectedCategory]);
  const getProductandCategory = async () => {
    let params = {};
    if (fromDate) params.date_from = moment(fromDate).format("YYYY-MM-DD");
    if (toDate) params.date_to = moment(toDate).format("YYYY-MM-DD");
    if (selectedProduct && selectedProduct?.name != "All")
      params.product_id = selectedProduct?.id;
    if (selectedCategory) params.category_id = selectedCategory?.id;

    await callApi("report/ProductandCategory")
      .withParam(params)
      .loadingGroup("product")
      .executeDispatch();
  };
  return (
    <div className="container mx-auto text-[14px] px-4">
      <h1 className="text-xl font-bold m-4 text-center">
        Sale Report By Product and Category
      </h1>
      <div className="flex items-center justify-start space-x-4 text-sm mb-6">
        <div className="flex flex-col">
          <DateFilter
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={handleFromDateChange}
            setToDate={handleToDateChange}
            // getProductandCategory={getProductandCategory}
          />

          {dateError && <p className="text-red-500 text-sm  ">{dateError}</p>}
        </div>
        {/* <div className="flex flex-col">
          <label htmlFor="usergroupDropdown" className="text-gray-700 mb-2">
            Select usergroup:
          </label>
          <DropdownFilter
            // defaultValue="usergroup"
            placeholder="select usergroup"
            dropdownItems={userGroup}
            valueKey="name"
            onSelect={(value) => setSelectedUsergroup(value)}
          />
        </div> */}
        <div className="flex flex-col">
          <label htmlFor="categoryDropdown" className="text-gray-700 mb-2">
            Select Category:
          </label>
          <DropdownFilter
            placeholder="select category"
            dropdownItems={category}
            onSelect={(value) => setSelectedCategory(value)}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="productDropdown" className="text-gray-700 mb-2">
            Select Product:
          </label>
          <DropdownFilter
            placeholder="select product"
            dropdownItems={allProductType}
            onSelect={(value) => setSelectedProduct(value)}
          />
        </div>
      </div>
      <LoadingComponent loadingGroup="product">
        {productReport?.length > 0 ? (
          <table className="w-full border-collapse border border-gray-300 shadow-md">
            <thead>
              <tr className="bg-[#164571] text-white-1">
                <th className="border border-gray-300 p-2">No</th>
                <th className="border border-gray-300 p-2">Product</th>
                <th className="border border-gray-300 p-2">Category</th>
                <th className="border border-gray-300 p-2">Total Quantity</th>
                <th className="border border-gray-300 p-2">
                  Total Sales Amount
                </th>
                <th className="border border-gray-300 p-2">
                  Total Gross Profit
                </th>
              </tr>
            </thead>
            <tbody>
              {productReport?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-100 text-center">
                  <td className="border border-gray-300 p-2">{index + 1}</td>
                  <td className="border border-gray-300 p-2">
                    {item?.product}
                  </td>
                  <td className="border border-gray-300 p-2">
                    {item?.category}
                  </td>

                  <td className="border border-gray-300 p-2">
                    {item?.total_quantity}
                  </td>
                  <td className="border border-gray-300 p-2 text-end">
                    {item?.total_sales_amount?.toLocaleString()}
                  </td>
                  <td className="border border-gray-300 p-2 text-end">
                    {item?.gross_profit
                      ? item?.gross_profit?.toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-md text-gray-500 mt-4">
            No data found for the selected filters.
          </p>
        )}
      </LoadingComponent>
    </div>
  );
};

export default ProductandCategory;
